package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_selection

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.ProductSetsModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_selection.UpdateProductSetRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdateProductSetRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateProductSetRepository {

    private var abortController = requestManager.createController()

    override suspend fun updateProductSet(
        id: String,
        title: String,
        value: dynamic
    ): ProductSetsModel {

        abortController = requestManager.createController()

        val query = """
           mutation updateProduct_sets(
               ${'$'}id: ID!,
               ${'$'}fields: ProductFields
           ){
               cashAssist {
                   updateProduct(id: ${'$'}id, fields:${'$'}fields) {
                       ...productRequired
                       sets {
                           category {
                               ${ApiUtils.Field.id}
                               ${ApiUtils.Field.name}
                               gridProducts {
                                   ${ApiUtils.Field.productId}
                                   product {
                                       ${ApiUtils.Field.id}
                                       ${ApiUtils.Field.code}
                                       ${ApiUtils.Field.name}
                                       ${ApiUtils.Field.__typename}
                                   }
                                   ${ApiUtils.Field.__typename}
                               }
                               ${ApiUtils.Field.__typename}
                           }
                           ${ApiUtils.Field.minQuantity}
                           ${ApiUtils.Field.maxQuantity}
                           ${ApiUtils.Field.priceLevel}
                           ${ApiUtils.Field.isCollectPoints}
                           ${ApiUtils.Field.weekDays}
                           ${ApiUtils.Field.course}
                           fixProducts {
                               ${ApiUtils.Field.code}
                               ${ApiUtils.Field.amount}
                               ${ApiUtils.Field.price}
                               ${ApiUtils.Field.__typename}
                           }
                           ${ApiUtils.Field.__typename}
                       }
                       ${ApiUtils.Field.priceDiffMode}
                       ${ApiUtils.Field.setsMode}
                       ${ApiUtils.Field.fixProductsAutoSelect}
                       ${ApiUtils.Field.isPricesNormalByDefaultInSet}
                       ${ApiUtils.Field.isMenuName}
                       ${ApiUtils.Field.__typename}
                   }
                   ${ApiUtils.Field.__typename}
               }
           }

           fragment productRequired on Product {
               ${ApiUtils.Field.id}
               ${ApiUtils.Field.mod_ver}
               ${ApiUtils.Field.name}
               ${ApiUtils.Field.checkOutCommandId}
               ${ApiUtils.Field.__typename}
           }

            
            """.trimIndent()

        val variables = buildJsonObject {
            put("id",id)
            putJsonObject("fields") {
                when(value)
                {
                    is Boolean->put(title, value as Boolean)
                    is String->put(title,value as String)
                    is Int->put(title,value as Int)
                }

            }
        }

        val graphQLQuery = buildJsonObject {
            put("query", query)
            put("variables", variables)
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

}
